var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"btn btn-sm btn-icon",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fas fa-minus"})])}
var staticRenderFns = []

export { render, staticRenderFns }